export default class PermissionManager {
    constructor(role, employeesCount, maxEmployees = 5, branchesCount, maxBranches = 1, billDate = null, isTrial = false, blocked = false) {
        this.role = role;
        this.employeesCount = employeesCount;
        this.branchesCount = branchesCount;
        this.maxEmployees = maxEmployees;
        this.billDate = billDate;
        this.blocked = blocked;
        this.isTrial = isTrial;
        this.maxBranches = maxBranches

    }

    canPushEmployees() {
        return !this.blocked && (this.role === 1 || this.role === 5) && (this.employeesCount < this.maxEmployees);
    }
    canUpdateEmployees() {
        return !this.blocked && (this.role === 1 || this.role === 5);
    }
    canPushApps() {
        return !this.blocked && this.role === 1;
    }

    canPushBranches() {
        return !this.blocked && this.role === 1 && (this.branchesCount < this.maxBranches);
    }
    canPushUpdateBranches() {
        return !this.blocked && (this.role === 1 ||   this.role === 5);
    }
    canPushpackages() {
        return !this.blocked && this.role === 3;
    }
    canPush() {
        return !this.blocked;
    }

    hasBill(date) {
        return this.billDate && new Date(this.billDate) >= new Date(date);
    }

    blockAccount() {
        this.blocked = true;
    }

    setBillDate(date) {
        this.billDate = date;
    }

    pushEmployee() {
        if (this.canPushEmployees()) {
            this.employeesCount++;
            return true;
        }
        return false;
    }

    pushApp() {
        return this.canPushApps();
    }

    pushBranch() {
        return this.canPushBranches();
    }
    createPermissionObject() {
        const currentDate = new Date();
        let daysLeft = null;
        let paymentMessage = false

        let localisTrial = false
        if (this.isTrial === 1) {
            localisTrial = true
        }

        const nextPaymentDate = new Date(this.billDate);
        // nextPaymentDate.setMonth(nextPaymentDate.getMonth() + 1); // Add one month to the bill date

        daysLeft = Math.ceil((nextPaymentDate - currentDate) / (1000 * 60 * 60 * 24));

        if (daysLeft <= 0) {
            paymentMessage = true
            // console.log("Your monthly payment is overdue. Please make the payment to continue using the service.");
        } else if (daysLeft === 1) {
            paymentMessage = true
            // console.log("Your monthly payment is due tomorrow. Please make the payment to continue using the service.");
        }

        return {
            employees: this.canPushEmployees(),
            updateEmployees: this.canUpdateEmployees(),
            apps: this.canPushApps(),

            canPush: this.canPush(),
            daysLeft: daysLeft,
            package: this.canPushpackages(),
            branch: this.canPushBranches(),
            updateBranch: this.canPushUpdateBranches(),
            paymentMessage: paymentMessage,
            trialMessage: localisTrial,
            isTrial: localisTrial, // Monthly payment scenario, not a trial
            blocked: this.blocked
        };

    }

}
